import React, { useRef } from 'react';
import Type from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import { useTranslation } from 'hooks';
import ConfirmDialog from '../../Feedback/ConfirmDialog';
import { initialValues, validationSchema } from './NewEmailDialog.mock';

const NewEmailDialog = (props) => {
  const { open, onConfirm, onCancel } = props;
  const { t } = useTranslation();
  const formRef = useRef();

  const handleSubmit = (formData) => {
    onConfirm(formData);
  };

  const handleConfirm = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <ConfirmDialog
      title={t('newEmail')}
      confirmLabel={t('add')}
      open={open}
      onConfirm={handleConfirm}
      onCancel={onCancel}
    >
      <Formik
        initialValues={initialValues}
        innerRef={formRef}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize
      >
        <Form noValidate>
          <Field name="email" label={t('email')} component={TextField} fullWidth />
        </Form>
      </Formik>
    </ConfirmDialog>
  );
};

NewEmailDialog.propTypes = {
  open: Type.bool.isRequired,
  onConfirm: Type.func.isRequired,
  onCancel: Type.func.isRequired,
};

export default NewEmailDialog;
